<div *ngIf="imageLoad.length" [ngStyle]="{ 'background-color': BgColor }">
  <carousel>
    <slide
      *ngFor="let imgSrc of imageLoad; let i = index"
      class="carousel slide carousel-fade img-size"
      [ngStyle]="{'text-align': !notCardImage? 'center': 'right'}"
    >
      <!-- <a href="{{ imgSrc.imgPath }}" target="_blank"> -->
        <img
          src="{{ imgSrc.imgPath }}"
          alt="..."
          class="img-size view-only"
          [ngStyle]="{
            width: !notCardImage
              ? imgSrc.height > max_Image_height && imgSrc.height > imgSrc.width
                ? (imgSrc.width / imgSrc.height) * max_Image_height + 'px'
                : '-webkit-fill-available'
              : (imgSrc.width / imgSrc.height) * max_Image_height + 'px'
          }"
      />
      <img
      alt="..."
      src="{{ imgSrc.imgPath }}"
      class="img-size print-only"
      />
    <!-- </a> -->
    </slide>
  </carousel>
</div>

<!-- <div *ngIf="imageLoad.length">
  <carousel>
    <slide
      *ngFor="let imgSrc of imageLoad; let i = index"
      class="carousel slide carousel-fade img-size"
      style="text-align: center;"
    >
      <a href="{{ imgSrc.imgPath }}" target="_blank">
        <img
          src="{{ imgSrc.imgPath }}"
          title="Click here to show larger Image!"
          alt="..."
          width="100%"
          class="img-size"
      /></a>
    </slide>
  </carousel>
</div> -->
<!-- <div *ngIf="!imgPath.length"><img src="/assets/img/bg/project-background.png" alt="..." class="card-img-top img-size"></div> -->
